export default __webpack_public_path__ + "static/media/mon_24.e935234f.png";